var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgJcb = function SvgJcb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 135,
    height: 100,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#JCB_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#JCB_svg__b)",
    d: "M101.337 60.872h9.71c.29 0 .93-.116 1.22-.116 1.861-.35 3.431-2.035 3.431-4.36 0-2.21-1.57-3.896-3.431-4.361-.29-.116-.814-.116-1.22-.116h-9.71z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#JCB_svg__c)",
    d: "M109.884-.29c-9.244 0-16.803 7.5-16.803 16.802v17.441h23.721c.582 0 1.221 0 1.686.117 5.349.29 9.303 3.023 9.303 7.849 0 3.779-2.675 7.035-7.675 7.674v.174c5.465.35 9.593 3.43 9.593 8.14 0 5.058-4.593 8.372-10.697 8.372H93.023v34.128h24.651c9.245 0 16.803-7.5 16.803-16.802V-.291z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#JCB_svg__d)",
    d: "M114.419 42.965c0-2.21-1.57-3.663-3.431-3.953-.174 0-.639-.117-.93-.117h-8.779v8.14h8.779c.291 0 .814 0 .93-.116 1.861-.233 3.431-1.744 3.431-3.954"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#JCB_svg__e)",
    d: "M17.035-.29C7.79-.29.233 7.21.233 16.511v41.453c4.709 2.326 9.593 3.78 14.476 3.78 5.814 0 8.954-3.49 8.954-8.315V33.837H38.08v19.477c0 7.558-4.709 13.779-20.697 13.779-9.71 0-17.268-2.151-17.268-2.151v35.349h24.651c9.245 0 16.803-7.5 16.803-16.803V-.29z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#JCB_svg__f)",
    d: "M63.488-.29c-9.244 0-16.802 7.5-16.802 16.802v21.976c4.244-3.604 11.628-5.93 23.547-5.349 6.395.291 13.197 2.035 13.197 2.035v7.093c-3.43-1.744-7.5-3.314-12.732-3.662-9.07-.64-14.477 3.779-14.477 11.511 0 7.85 5.465 12.268 14.477 11.512 5.232-.349 9.302-2.035 12.732-3.663v7.093s-6.744 1.744-13.197 2.035c-11.919.581-19.303-1.744-23.547-5.349v38.779h24.651c9.244 0 16.803-7.5 16.803-16.802V-.291z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "JCB_svg__b",
    x1: 93.081,
    x2: 134.552,
    y1: 56.46,
    y2: 56.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.229,
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.743,
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "JCB_svg__c",
    x1: 93.08,
    x2: 134.516,
    y1: 50.047,
    y2: 50.047,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.229,
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.743,
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "JCB_svg__d",
    x1: 93.08,
    x2: 134.552,
    y1: 42.987,
    y2: 42.987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#007940"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.229,
    stopColor: "#00873F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.743,
    stopColor: "#40A737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5CB531"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "JCB_svg__e",
    x1: 0.239,
    x2: 42.351,
    y1: 50,
    y2: 50,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F286F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.475,
    stopColor: "#004E94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.826,
    stopColor: "#0066B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006FBC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "JCB_svg__f",
    x1: 46.439,
    x2: 87.34,
    y1: 50.093,
    y2: 50.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6C2C2F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.173,
    stopColor: "#882730"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.573,
    stopColor: "#BE1833"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.859,
    stopColor: "#DC0436"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60039"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "JCB_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h134.884v100H0z"
  })))));
};
export default SvgJcb;